import { Currency, Country, CURRENCY_KEY, COUNTRY_KEY } from '../constants';
import Cookies from 'js-cookie';

export const getCurrencyCookie = () => {
  return Cookies.get(CURRENCY_KEY) as Currency | undefined;
};

export const setCurrencyCookie = (currency: Currency) => {
  Cookies.set(CURRENCY_KEY, currency);
};
export const setCountryCookie = (country: Country) => {
  Cookies.set(COUNTRY_KEY, country);
};

/**
 * Formats amount with the appropriate currency symbol based on the country.
 * @param {string} country - The name of the country.
 * @param {number|string} amount - The amount to format.
 * @returns {string} - The formatted amount with currency symbol.
 */

export function formatCurrency(country: Currency, amount: number | string): string {
  type CurrencyInfo = {
    [key in Currency]: { symbol: string; position: 'prefix' | 'suffix' };
  };
  const formattedAmount = Number(amount).toFixed(2);

  const currencyInfo: CurrencyInfo = {
    [Currency.Australia]: { symbol: 'A$', position: 'prefix' },
    [Currency.Canada]: { symbol: 'CA$', position: 'prefix' },
    [Currency.Malaysia]: { symbol: 'RM', position: 'prefix' },
    [Currency.NewZealand]: { symbol: 'NZ$', position: 'prefix' },
    [Currency.Qatar]: { symbol: 'QR', position: 'prefix' },
    [Currency.SaudiArabia]: { symbol: 'ر.ق', position: 'suffix' },
    [Currency.Singapore]: { symbol: 'S$', position: 'prefix' },
    [Currency.UnitedArabEmirates]: { symbol: 'د.إ', position: 'suffix' },
    [Currency.UnitedKingdom]: { symbol: '£', position: 'prefix' },
    [Currency.UnitedStates]: { symbol: '$', position: 'prefix' },
  };

  if (!currencyInfo[country]) {
    return formattedAmount.toString();
  }

  const { symbol, position } = currencyInfo[country];

  if (position === 'prefix') {
    return `${symbol}${formattedAmount}`;
  } else {
    return `${formattedAmount} ${symbol}`;
  }
}
